import { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";

// Animates a KPI number from its previous value to the next one whenever it
// changes (e.g. a stat card's count after a fetch resolves), instead of the
// number just popping in. Non-numeric values (null, "N/A", a percentage
// string, ...) pass through unanimated -- only real numbers are counted up.
export default function useCountUp(value, { duration = 0.6 } = {}) {
  const isNumeric = typeof value === "number" && Number.isFinite(value);
  const [display, setDisplay] = useState(isNumeric ? value : value);
  const prevNumericRef = useRef(isNumeric ? value : 0);

  useEffect(() => {
    if (!isNumeric) {
      setDisplay(value);
      return undefined;
    }

    const from = prevNumericRef.current;
    const controls = animate(from, value, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    prevNumericRef.current = value;
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, isNumeric, duration]);

  return display;
}
